import React from 'react';

import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';

import ActionButtonLink from 'components/action-button';
import { Box, Typography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

type ActionButtonLinkProps = React.ComponentProps<typeof ActionButtonLink>;

const getActionButtonLinkStyle = (style: ActionButtonLinkProps['style']) =>
  typeof style === 'function' ? style : [styles.actionButtonLink, style];

export const EmptyStateWrapper = ({ style, ...props }: BoxProps) => {
  const paddingHorizontal = useBreakpointValue({
    base: spacing.$8,
    md: spacing.$0,
  });

  return React.createElement(Box, {
    ...props,
    style: [styles.emptyStateWrapper, { paddingHorizontal }, style],
  });
};

export const StyledActionButtonLink = ({ _text, style, ...props }: ActionButtonLinkProps) =>
  React.createElement(ActionButtonLink, {
    ...props,
    _text: { fontFamily: 'heading', ..._text },
    style: getActionButtonLinkStyle(style),
  });

export const HeaderText = ({ style, ...props }: TypographyProps) =>
  React.createElement(Typography, {
    ...props,
    color: primitive.$bbqBrown,
    fontSize: '2xl',
    lineHeight: 'md',
    style: [styles.headerText, style],
    textAlign: 'center',
    variant: 'headerFour',
  });

export const SubText = ({ style, ...props }: TypographyProps) =>
  React.createElement(Typography, {
    ...props,
    color: primitive.$bbqBrown,
    fontSize: 'md',
    style: [styles.subText, style],
    textAlign: 'center',
  });

export const ImageWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.imageWrapper, style],
  });

const styles = StyleSheet.create({
  actionButtonLink: {
    marginTop: spacing.$6,
  },
  emptyStateWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: spacing.$8,
    paddingVertical: spacing.$0,
  },
  headerText: {
    margin: spacing.$0,
    marginTop: spacing.$5,
  },
  imageWrapper: {
    height: spacing.$40,
    width: spacing.$40,
  },
  subText: {
    marginHorizontal: spacing.$16,
    marginTop: spacing.$1,
  },
});
